import {Component, NgModule} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrls: ['./footer.scss']
})
export class Footer {
    
}


@NgModule({
  imports: [ MatIconModule, MatButtonModule, MatToolbarModule ],
  exports: [Footer],
  declarations: [Footer],
})
export class FooterModule {}